import React, { useEffect, useRef, useState } from 'react';
import { useTranslation } from "react-i18next";

const OurClients = () => {
  const scrollRef = useRef(null);
  const [activeIndex, setActiveIndex] = useState(0);
  const [itemsPerPage, setItemsPerPage] = useState(4);
  const { t } = useTranslation();

  const clients = [
    { name: 'Les Seraphins', logo: '', url: 'https://seraphins.ca' },
    { name: 'Maloo Store', logo: '', url: '#' },
    { name: 'École Nationale de Lalue', logo: '', url: '#' },
    { name: 'Malina Provisions Alimentaires', logo: '', url: '#' },
    { name: 'HG Services Windows', logo: '', url: '#' }
  ];

  const updateItemsPerPage = () => {
    const width = window.innerWidth;
    if (width < 640) setItemsPerPage(1);         // mobile
    else if (width < 768) setItemsPerPage(2);    // petit écran
    else if (width < 1024) setItemsPerPage(3);   // moyen écran
    else setItemsPerPage(4);                     // grand écran
  };

  useEffect(() => {
    updateItemsPerPage();
    window.addEventListener('resize', updateItemsPerPage);
    return () => window.removeEventListener('resize', updateItemsPerPage);
  }, []);

  const totalPages = Math.ceil(clients.length / itemsPerPage);

  useEffect(() => {
    const scrollContainer = scrollRef.current;
    if (!scrollContainer) return;

    const interval = setInterval(() => {
      setActiveIndex((prevIndex) => {
        const newIndex = (prevIndex + 1) % totalPages;
        scrollContainer.scrollTo({
          left: newIndex * scrollContainer.clientWidth,
          behavior: 'smooth',
        });
        return newIndex;
      });
    }, 10000);

    return () => clearInterval(interval);
  }, [totalPages]);

  const goToSlide = (index) => {
    if (!scrollRef.current) return;
    setActiveIndex(index);
    scrollRef.current.scrollTo({
      left: index * scrollRef.current.clientWidth,
      behavior: 'smooth',
    });
  };

  return (
    <section className="py-12 bg-gray-100 dark:bg-gray-800">
      <div className="w-full mx-auto px-4 text-center">
        <h2 className="text-3xl font-bold text-blue-600 mb-10">{t('Nos Clients')}</h2>

        <div className="relative overflow-hidden">
          <div
            ref={scrollRef}
            className="flex px-4 py-6"
            style={{
              scrollBehavior: 'smooth',
              whiteSpace: 'nowrap',
              scrollSnapType: 'x mandatory',
              overflowX: 'hidden',
            }}
          >
            {clients.map((client, index) => (
              <div
                key={index}
                className="flex-shrink-0 flex flex-col items-center px-2"
                style={{
                  width: `${100 / itemsPerPage}%`,
                }}
              >
                <a
                  href={client.url}
                  target="_blank"
                  rel="noopener noreferrer"
                  className="flex justify-center"
                >
                  {client.logo ? (
                    <img
                      src={client.logo}
                      alt={client.name}
                      className="w-24 h-24 rounded-full object-cover shadow-lg"
                    />
                  ) : (
                    <div className="w-24 h-24 rounded-full bg-blue-600 text-white flex items-center justify-center text-xl font-bold uppercase shadow-lg">
                      {client.name
                        .split(' ')
                        .map((word) => word[0])
                        .join('')}
                    </div>
                  )}
                </a>
                <p
                  className={`mt-3 text-lg capitalize ${
                    client.name === 'Les Seraphins'
                      ? 'text-blue-600 font-bold'
                      : 'text-gray-700 dark:text-gray-200'
                  }`}
                >
                  {client.name}
                </p>
              </div>
            ))}
          </div>

          <div className="flex justify-center mt-4">
            {Array.from({ length: totalPages }).map((_, index) => (
              <button
                key={index}
                onClick={() => goToSlide(index)}
                className={`h-3 w-3 mx-1 rounded-full ${
                  index === activeIndex ? 'bg-blue-600 w-4' : 'bg-gray-400'
                } transition-all duration-300`}
              />
            ))}
          </div>
        </div>
      </div>
    </section>
  );
};

export default OurClients;
